import React from "react";
import * as styles from "@styles/OuroborosSpinner.css";

const OuroborosSpinnerComponent: React.FC = () => {
  return (
    <div className={styles.container}>
      <img
        className={styles.logo}
        src="/assets/ouroboros_logo_flat.png"
        alt="Loading"
      />
    </div>
  );
};

export default OuroborosSpinnerComponent;
